(ns frontend.view.modals.components.input
  (:require
   [frontend.view.components.clipboard :as clipboard]
   [reagent.core :as r]
   [ui.editors.labelled-input.view :as labelled-input]))

(defn simple-text-field
  [_props]
  (let [local (r/atom {:dirty? false :value nil})]
    (fn [{:keys [type entity attribute mandatory? label placeholder
                 read-only? disabled? dom-id on-save! validate! info-text]}]
      (let [data-type   (case type
                          :textarea :data.type/text-multiline
                          :email    :data.type/email
                          :data.type/text-simple)
            entity-value (get entity attribute)
            current     (if (:dirty? @local) (:value @local) entity-value)
            error       (when (fn? validate!) (validate! attribute current))]
        [:div
         [labelled-input/with-actions
          {:tools (clipboard/copy-tool current nil)}
          [labelled-input/view
           {:dom-id      dom-id
            :data-type   data-type
            :label       label
            :placeholder placeholder
            :mandatory?  mandatory?
            :disabled?   (boolean (or disabled? read-only?))
            :read-only?  (boolean read-only?)
            :info-text   info-text
            :value       current
            :error       error
            :on-change   (fn [new-value]
                           (reset! local {:dirty? true :value new-value}))
            :on-blur     (fn [_]
                           (let [v (if (:dirty? @local) (:value @local) entity-value)
                                 err (when (fn? validate!) (validate! attribute v))]
                             (when (and (not err) (fn? on-save!))
                               (on-save! attribute v
                                         (fn []
                                           (reset! local {:dirty? false :value nil}))
                                         (fn [_])))))}]]
         (when error
           [:p {:class "text-xs text-danger-light-text"} error])]))))
